export default {
    init() {
        /***Annual report js***/
        jQuery(window).scroll(function () {
            var scroll = jQuery(window).scrollTop();
            //>=, not <=
            if (scroll >= 50) {
                jQuery('.main-header').addClass('headerFix');
            } else {
                jQuery('.main-header').removeClass('headerFix');
            }
        });
        jQuery(document).ready(function () {
            jQuery('#moveSectionDown').on('click', function () {
                if (jQuery(window).width() < 767) {
                    jQuery('html, body').animate(
                        {
                            scrollTop: jQuery('#scroll').offset().top - 69,
                        },
                        1000
                    );
                } else {
                    jQuery('html, body').animate(
                        {
                            scrollTop: $('#scroll').offset().top - 74,
                        },
                        1000
                    );
                }
            });
        });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/annual-report.js